import { initializeApp } from "firebase/app";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCUjIdco2V6PeSiaG_d7siuA_JOaDRAsfo",
  authDomain: "shehrullah-khidmat-bot-v1.firebaseapp.com",
  projectId: "shehrullah-khidmat-bot-v1",
  storageBucket: "shehrullah-khidmat-bot-v1.firebasestorage.app",
  messagingSenderId: "523374951409",
  appId: "1:523374951409:web:9a4e67dbf4252d45b52250",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const login = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );
    return userCredential.user;
  } catch (error) {
    throw error;
  }
};

const logout = async () => {
  await signOut(auth);
};

const getCurrentUser = () => {
  return auth.currentUser;
};

export { auth, getCurrentUser, login, logout };
